import React, { createContext, useCallback, useEffect, useState } from 'react';
import authApi from '../api/auth';
import { TokenStore } from '../api/client';

export const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user,      setUser]      = useState(null);
  const [isLoading, setIsLoading] = useState(true);  // true on mount while we validate token

  // On mount: if a token exists, fetch the current user to hydrate context
  useEffect(() => {
    const token = TokenStore.getAccess();
    if (!token) {
      setIsLoading(false);
      return;
    }
    authApi.me()
      .then(setUser)
      .catch(() => TokenStore.clear())
      .finally(() => setIsLoading(false));
  }, []);

  const login = useCallback(async (email, password) => {
    await authApi.login(email, password);
    const me = await authApi.me();
    setUser(me);
    return me;
  }, []);

  const logout = useCallback(async () => {
    await authApi.logout();
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider value={{ user, isLoading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
